import { Store as VuexStore } from 'vuex';
import { State } from '@/primary/store/storeOptions';
import { Mission } from '@/domain/project/Mission';
import { Project } from '@/domain/project/Project';
import { Country } from '@/domain/country/Country';
import { CountryLabel } from '@/domain/country/CountryLabel';
import { ResearchUnit } from '@/domain/research-unit/ResearchUnit';
import { GeoJSON } from 'ol/format';

export class Store {
  constructor(private store: VuexStore<State>) {}

  saveResearchUnits(researchUnits: ResearchUnit[]): void {
    this.store.commit('saveResearchUnits', researchUnits);
  }

  getFilteredResearchUnits(): ResearchUnit[] {
    return this.store.getters.filteredResearchUnits;
  }

  saveDepartmentFilter(department: string): void {
    this.store.commit('saveDepartmentFilter', department);
  }

  saveResearchUnitFilter(researchUnitId?: number): void {
    this.store.commit('saveResearchUnitFilter', researchUnitId);
  }

  getResearchUnitFilter(): number | undefined {
    return this.store.state.researchUnitFilter;
  }

  saveMissionFilter(missions: Mission[]): void {
    this.store.commit('saveMissionFilter', missions);
  }

  getMissionFilter(): Mission[] {
    return this.store.state.missionFilter;
  }

  saveProjects(projects: Project[]): void {
    this.store.commit('saveProjects', projects);
  }

  getProjects(): Project[] {
    return this.store.state.projects;
  }

  getFilteredProjects(): Project[] {
    return this.store.getters.filteredProjects;
  }

  getProjectCountsByCountry(): { [key: string]: number } {
    return this.store.getters.projectCountsByCountry;
  }

  saveCountries(countries: Country[]): void {
    this.store.commit('saveCountries', countries);
  }

  getCountries(): Country[] {
    return this.store.state.countries;
  }

  saveCountryLabelFeatureCollection(countryLabelFeatureCollection: GeoJSON.FeatureCollection<GeoJSON.Point, CountryLabel>): void {
    this.store.commit('saveCountryLabelFeatureCollection', countryLabelFeatureCollection);
  }

  getCountryLabelFeatureCollection(): GeoJSON.FeatureCollection<GeoJSON.Point, CountryLabel> {
    return this.store.state.countryLabelFeatureCollection;
  }
}
